import { useRef } from 'react';

import type { HandleFeedbackSubmissionArgs } from './useEditorPluginAI';

export interface EditorPluginAIFeedbackHandlersRef {
	handleFeedbackClicked: (props: HandleFeedbackSubmissionArgs) => void;
	handleReviewStateEntered: () => void;
	handleExperienceEnded: () => void;
}

/**
 * This hook serves to pull handlers and wait for them to be ready, so that
 * we can pass callbacks immediately to the `editor plugin ai`
 * (TBC on how extensively Intercom will be used in Confluence)
 */
export const useEditorPluginAIFeedbackHandlers = () => {
	const editorPluginAIFeedbackHandlers = useRef<EditorPluginAIFeedbackHandlersRef>({
		handleFeedbackClicked: () => {},
		handleReviewStateEntered: () => {},
		handleExperienceEnded: () => {},
	});

	return {
		editorPluginAIFeedbackHandlers,
	};
};
